var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMysession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3575_4690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.57359C0 7.18998 0 6.80637 0 6.42641C0.0438528 6.41179 0.0255808 6.37161 0.0292352 6.34603C0.054816 6.08664 0.09136 5.8309 0.146176 5.57881C0.75646 2.68894 3.05508 0.522443 5.9786 0.0730689C6.12843 0.0511482 6.28191 0.0621086 6.42443 0C6.78987 0 7.15531 0 7.5171 0C7.52441 0.0292276 7.54999 0.0255741 7.57191 0.0255741C7.94466 0.0474948 8.31376 0.109603 8.67554 0.200939C12.3555 1.11795 14.6432 4.78601 13.8429 8.47599C13.006 12.3194 9.17254 14.7307 5.36466 13.8064C2.58001 13.1268 0.500653 10.8507 0.073088 8.01931C0.0511616 7.86952 0.0621248 7.71607 0 7.57359ZM6.50117 5.00156C6.50117 5.63361 6.50848 6.26931 6.49752 6.90136C6.49387 7.13518 6.57426 7.30689 6.76064 7.45303C7.21378 7.80376 7.65962 8.1691 8.10546 8.52714C8.45993 8.81211 8.81441 9.09708 9.17254 9.37839C9.45393 9.5976 9.82668 9.50261 9.95823 9.18841C10.0459 8.97286 9.98747 8.75365 9.79013 8.5929C9.06291 8.00835 8.33568 7.4238 7.60115 6.8429C7.52075 6.78079 7.49152 6.71503 7.49152 6.61639C7.49517 5.43633 7.49517 4.25626 7.49517 3.0762C7.49517 2.9666 7.49152 2.85699 7.43305 2.75835C7.32341 2.56106 7.1005 2.46242 6.87392 2.51357C6.65831 2.56472 6.50117 2.75835 6.49752 2.99217C6.50117 3.66075 6.50117 4.33298 6.50117 5.00156Z",
    fill: "#AAA4C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3575_4690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysession);
export default __webpack_public_path__ + "static/media/mysession.e5b873652f98a3f96e291980a0efe188.svg";
export { ForwardRef as ReactComponent };